import { toPickerHex } from './pickerHex';

interface Props {
  'aria-label': string;
  /** Any CSS colour string; the picker itself only understands #rrggbb. */
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean | undefined;
}

/** Colour picker with a hex readout — the colour twin of RangeInput. */
export function ColorField({ value, onChange, disabled = false, ...rest }: Props) {
  return (
    <div className="flex items-center gap-3">
      <input
        type="color"
        aria-label={rest['aria-label']}
        value={toPickerHex(value)}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        className="h-7 w-10 cursor-pointer rounded border border-[var(--co-border)] bg-transparent p-0 disabled:cursor-not-allowed disabled:opacity-50"
      />
      <span className="font-mono text-[12px] text-[var(--co-text)]">{value}</span>
    </div>
  );
}
